import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import { Button } from '@/components/ui/button'; // Import Button component
import { ArrowLeft } from 'lucide-react'; // Import icon for the button
import { getSetting } from '@/integrations/supabase/client'; // Import the function to get settings

const ReturnPolicy: React.FC = () => {
  const [content, setContent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Use the correct key for return policy content
        const fetchedContent = await getSetting('return_policy_content'); 
        setContent(fetchedContent);
      } catch (err: any) {
        console.error("Error fetching return policy content:", err);
        setError('Erro ao carregar o conteúdo. Tente novamente mais tarde.');
        setContent(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Back to Store Button */}
      <Link to="/" className="inline-flex items-center mb-6 text-sm text-blue-600 hover:underline">
        <ArrowLeft size={16} className="mr-1" />
        Voltar para a Loja
      </Link>

      <h1 className="text-2xl font-bold mb-6">Política de Devolução</h1>

      {isLoading && (
        <div className="text-center py-10">Carregando conteúdo...</div>
      )}

      {error && (
        <div className="text-center py-10 text-red-600">{error}</div>
      )}

      {!isLoading && !error && content && (
        // Render as plain text (safer)
        <div className="prose max-w-none whitespace-pre-wrap">
          {content}
        </div>
        // Or uncomment below to render as HTML (use with caution)
        // <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: content }} />
      )}

      {!isLoading && !error && !content && (
        <div className="text-center py-10 text-gray-500">Nenhum conteúdo disponível para a Política de Devolução.</div>
      )}
    </div>
  );
};

export default ReturnPolicy;
